module.exports = __webpack_public_path__ + "img/facebook-color.a5359750.svg";